import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
const BasicText = ({
  content
}) => {
  const {
    label,
    variant,
    terms = []
  } = content;
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    mt: 1
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: variant ? variant : "body2"
  }, label), terms.length > 0 && /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row"
  }, terms.map((term, index) => /*#__PURE__*/React.createElement(Typography, {
    variant: variant ? variant : "body2",
    color: "primary",
    sx: {
      cursor: "pointer",
      color: theme => theme.palette.primary.main
    },
    onClick: () => window.open(term.link, "_blank").focus(),
    key: index,
    ml: terms.length > 1 ? 0.5 : 0
  }, term.label, terms.length > 1 && terms.length !== index + 1 && ", "))));
};
export default BasicText;
BasicText.propTypes = {
  content: PropTypes.object.isRequired
};